import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  COMPLETED_COURSES_GET,
  DASHBOARD_INFO_GET,
  EMPTY_COURSES_GET,
  LAST_COURSES_GET,
} from '../actions/dashboard';

const initialState = {
  completion_status: null,
  course_status: null,
  total_courses: 0,
  monthly_completed: null,
  emptyCourses: {
    list: [],
    filters: {},
    pager: {},
  },
  lastCourses: {
    list: [],
    filters: {},
    pager: {},
  },
  completedCourses: {
    list: [],
    filters: {},
    pager: {},
  },
};

const userReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case DASHBOARD_INFO_GET._SUCCESS: {
        const { response = {} } = action;
        draft = { ...response };
        draft.emptyCourses = state.emptyCourses;
        draft.lastCourses = state.lastCourses;
        draft.completedCourses = state.completedCourses;
        draft.filters = state.filters;
        break;
      }

      case EMPTY_COURSES_GET._SUCCESS: {
        const { response = {}, pager = {} } = action;
        draft.emptyCourses.list = response?.items || [];
        draft.emptyCourses.pager = pager;
        draft.emptyCourses.filters = {
          ...state.filters,
          ...(response?.filters || {}),
        };
        break;
      }

      case LAST_COURSES_GET._SUCCESS: {
        const { response = {}, pager = {} } = action;
        draft.lastCourses.list = response?.items || [];
        draft.lastCourses.pager = pager;
        draft.lastCourses.filters = {
          ...state.filters,
          ...(response?.filters || {}),
        };
        break;
      }

      case COMPLETED_COURSES_GET._SUCCESS: {
        const { response = {}, pager = {} } = action;
        draft.completedCourses.list = response?.items || [];
        draft.completedCourses.pager = pager;
        draft.completedCourses.filters = {
          ...state.filters,
          ...(response?.filters || {}),
        };
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default userReducer;
